module.exports = __webpack_public_path__ + "img/76.ba87c7af.jpg";